module.exports = __webpack_public_path__ + "img/logo2-en.ddf011ed.png";